// src/components/operationsAssociate/EditItemModal.jsx
import React, { useState, useEffect } from "react"; // MODIFIED: Added useEffect
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";

const API_URL = "https://ims.holdthechild.net";

const FormField = ({ label, name, value, onChange, type = "text", placeholder, options, required = false }) => {
    const isSelect = type === "select";
    const inputClass = "w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500";
    return (
        <div>
            <label htmlFor={name} className="block mb-1 font-medium text-gray-700">
                {label}{required && <span className="text-red-500 ml-1">*</span>}
            </label>
            {isSelect ? (
                <select id={name} name={name} value={value} onChange={onChange} className={inputClass}>
                    {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
            ) : (
                <input
                    id={name}
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={inputClass}
                    required={required}
                />
            )}
        </div>
    );
};

export default function EditItemModal({ closeModal, onUpdate, item }) {
    const [formData, setFormData] = useState({
        name: item.name,
        category: item.category,
        unitOfMeasure: item.unitOfMeasure,
        minStockLevel: item.minStockLevel,
        unitPrice: item.unitPrice,
        location: item.location,
        notes: item.notes,
        vendorId: item.vendor?._id || "", // ADDED: State for vendor ID with initial value
    });
    const [vendors, setVendors] = useState([]); // ADDED: State to store vendor list
    const [loading, setLoading] = useState(false);

    // ADDED: Fetch vendors on component mount
    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(`${API_URL}/api/vendors`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setVendors(response.data.data);
            } catch (error) {
                console.error("Failed to fetch vendors:", error);
                toast.error("Failed to load vendors. 😥");
            }
        };
        fetchVendors();
    }, []);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "number" ? parseFloat(value) : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem("token");

        const submissionData = {
            ...formData,
            minStockLevel: Number(formData.minStockLevel),
            unitPrice: Number(formData.unitPrice),
            vendor: formData.vendorId || null, // MODIFIED: Send vendor ID
        };

        try {
            await axios.put(`${API_URL}/api/inventory/${item._id}`, submissionData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            toast.success("Item updated successfully! 🎉");
            onUpdate();
            closeModal();
        } catch (error) {
            const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
            toast.error(`Error: ${errorMessage} 😥`);
        } finally {
            setLoading(false);
        }
    };

    const categoryOptions = [
        { value: "Office Supplies", label: "Office Supplies" },
        { value: "Food & Hygiene", label: "Food & Hygiene" },
        { value: "Electronics", label: "Electronics" },
        { value: "Stationery", label: "Stationery" },
        { value: "Other", label: "Other" },
    ];

    // ADDED: Vendor options for the select dropdown
    const vendorOptions = [{ value: "", label: "Select a Vendor" }, ...vendors.map(v => ({ value: v._id, label: v.name }))];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-4">
                    <h2 className="text-2xl font-bold text-orange-600">Edit Inventory Item</h2>
                    <button type="button" onClick={closeModal} className="text-3xl text-gray-400 hover:text-red-500 font-light">&times;</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <FormField label="Item Name" name="name" value={formData.name} onChange={handleChange} required />
                        <FormField label="Category" name="category" type="select" value={formData.category} onChange={handleChange} options={categoryOptions} />
                        <FormField label="Unit of Measure" name="unitOfMeasure" value={formData.unitOfMeasure} onChange={handleChange} />
                        <FormField label="Storage Location" name="location" value={formData.location} onChange={handleChange} />
                        <FormField label="Minimum Stock Level" name="minStockLevel" type="number" value={formData.minStockLevel} onChange={handleChange} min="0" />
                        <FormField label="Unit Price ($)" name="unitPrice" type="number" value={formData.unitPrice} onChange={handleChange} min="0" />
                        {/* ADDED: Vendor field */}
                        <FormField
                            label="Vendor"
                            name="vendorId"
                            type="select"
                            value={formData.vendorId}
                            onChange={handleChange}
                            options={vendorOptions}
                        />
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">Notes</label>
                            <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" className="w-full border rounded-md px-3 py-2" />
                        </div>
                    </div>

                    <div className="flex justify-end gap-4 mt-8 pt-4 border-t border-gray-200">
                        <button type="button" onClick={closeModal} className="px-5 py-2 rounded-md border border-gray-300 hover:bg-gray-50" disabled={loading}>Cancel</button>
                        <button type="submit" className="px-5 py-2 rounded-md bg-orange-600 text-white hover:bg-orange-700 disabled:opacity-50" disabled={loading}>
                            {loading ? "Updating..." : "Update Item"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}